@if (loadingUI === LoadingUI.Spinner) {
  <app-loading-spinner [isLoading]="isLoading" />
}
<div class="bs-table no-wrap" [ngClass]="{ resizableColumns }">
  <div
    class="dataViewTable"
    data-cy="dataViewTable"
    data-testid="dataViewTable"
    [style]="'grid-template-columns: ' + columnWidths.join(' ') + ';'"
  >
    @for (column of columns; track column; let columnIndex = $index) {
      <div [class]="'cell headCell tableColumn' + columnIndex + 'Item'" data-testid="dataViewHeadCell">
        <span (click)="onHeaderSortClick(column)">
          @if (sortField === column.field) {
            <span>
              <i class="fas" [class.fa-arrow-up]="sortOrder === 'asc'" [class.fa-arrow-down]="sortOrder === 'desc'"></i>
            </span>
          }
          <span data-testid="dataViewHeadCellLabel"> {{ column.display }} </span>
        </span>
        @if (resizableColumns) {
          <chitin-icon
            class="resizeDragger"
            (mousedown)="onMouseDragBegin(columnIndex)"
            (dblclick)="onDoubleClick(columnIndex)"
            icon="fa-solid fa-pipe"
          />
        }
      </div>
    }

    @if (data.length <= 0 && !isLoading && columns && columns.length > 0) {
      <div [style.grid-column]="'1 / span ' + columns.length" class="empty-table">
        <div class="alert alert-warning" role="alert">
          <div class="alert-message" data-cy="emptyTableText" data-testid="emptyTableText">No results found</div>
        </div>
      </div>
    }
    @if (isFetchingRows) {
      <div
        class="d-flex justify-content-center align-items-center pt-4"
        style="height: 20rem"
        [style.grid-column]="'1 / span ' + columns.length"
      >
        <app-loading-spinner [isLoading]="true" />
      </div>
    }
    @if ((!columns || columns.length === 0) && !isFetchingRows) {
      <div class="empty-table">
        <div class="alert alert-warning" role="alert">
          <div class="alert-message" data-cy="emptyTableText" data-testid="emptyTableText">
            No columns found. Please contact customer support for assistance.
          </div>
        </div>
      </div>
    }
    @if (columns && columns.length > 0) {
      @if (isLoading && loadingUI === LoadingUI.Placeholder && (!showLoadingInitOnly || data.length <= 0)) {
        @for (_ of [].constructor(loadingRowsCount); track $index) {
          @for (column of columns; track column) {
            <div class="placeholder-glow py-1">
              <span class="placeholder ms-3 col-9">L</span>
            </div>
          }
        }
      }
      @if (loadingUI !== LoadingUI.Placeholder || !isLoading || showLoadingInitOnly) {
        @for (item of data; track item; let itemIndex = $index) {
          <div [class]="'cellRow cellRow' + itemIndex" [ngClass]="{ active: activeRowId === itemIndex }">
            <!-- row-rise lives on the .cell (the real box): .cellRow is display:contents
            and has no box, so transform/opacity animations do nothing there. All
            cells in a row share --cl-row-i = itemIndex, so the row rises as one. -->
            @for (column of columns; track column; let columnIndex = $index) {
              <div
                class="cell row-rise"
                data-testid="dataViewCell"
                [ngClass]="{ clickable: itemClicked.observers.length > 0 }"
                [style.--cl-row-i]="itemIndex"
                #cell
                (click)="onItemClick(item, itemIndex, column, $event, cell)"
              >
                @if (column.templateRef) {
                  <span
                    class="cell-value"
                    [ngTemplateOutlet]="templates[column.templateRef]"
                    [ngTemplateOutletContext]="{ item, index: itemIndex, column }"
                  ></span>
                }
                @if (!column.templateRef) {
                  <span placement="top" ngbTooltip="{{ item | gridField: column }}" container="body">
                    {{ item | gridField: column }}
                  </span>
                }
              </div>
            }
          </div>
        }
      }
    }
  </div>
</div>
